export default __webpack_public_path__ + "static/lookbook-3-50d56ab7b02f08b801960c92ed63d085.webp";